import { render } from "./InputData.vue?vue&type=template&id=2a675578"
import script from "./InputData.vue?vue&type=script&lang=js"
export * from "./InputData.vue?vue&type=script&lang=js"

import "./InputData.vue?vue&type=style&index=0&id=2a675578&lang=scss"

import exportComponent from "/builds/root/lvgou_pub_mob/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__